import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .advice-container { 
      
    }

    .advice {
      color: ${theme.titleColor};
      line-height: 20px;
      text-align: justify;
      font-weight: 100;
    }
  `;
};
export default styles;
